'use client';
import { useEffect } from 'react';

export const OrServiceAreasClient = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Replaces phone number
      window?.Invoca?.PNAPI?.run();
    }
  }, []);
  return null;
};
